"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

var _body = require("./body");

/**
Dialog Hooks, like the file name says
Handles management of open/close state
Adding/removing CSS classes to body/html
*/
function useAnimatedModalState(params) {
  if (params === void 0) {
    params = {};
  }

  var _params = params,
      initialStatus = _params.status,
      onToggle = _params.onToggle;

  var _useState = (0, _react.useState)(initialStatus || 'initial'),
      status = _useState[0],
      setStatus = _useState[1];

  var bodyElem = (0, _react.useRef)();
  var htmlElem = (0, _react.useRef)();
  var componentRef = (0, _react.useRef)();
  var afterOpen = (0, _react.useCallback)(function () {
    if (componentRef.current) {
      componentRef.current.removeEventListener('transitionend', afterOpen);
    }

    setStatus('open');
  }, [componentRef, setStatus]);
  var afterClose = (0, _react.useCallback)(function () {
    if (componentRef.current) {
      componentRef.current.removeEventListener('transitionend', afterClose);
    }

    setStatus('closed');
  }, [componentRef, setStatus]);
  var clearListeners = (0, _react.useCallback)(function () {
    if (componentRef.current) {
      componentRef.current.removeEventListener('transitionend', afterOpen);
      componentRef.current.removeEventListener('transitionend', afterClose);
    }
  }, [componentRef, afterOpen, afterClose]);
  var addBodyClasses = (0, _react.useCallback)(function () {
    if (bodyElem && bodyElem.current) {
      (0, _body.disableScroll)(bodyElem.current);
    }

    if (htmlElem && htmlElem.current) {
      (0, _body.disableScroll)(htmlElem.current);
    }
  }, [bodyElem, htmlElem]);
  var removeBodyClasses = (0, _react.useCallback)(function () {
    if (bodyElem && bodyElem.current) {
      (0, _body.enableScroll)(bodyElem.current);
    }

    if (htmlElem && htmlElem.current) {
      (0, _body.enableScroll)(htmlElem.current);
    }
  }, [bodyElem, htmlElem]);
  var animateOpen = (0, _react.useCallback)(function () {
    if (componentRef.current) {
      componentRef.current.addEventListener('transitionend', afterOpen);
    }

    setStatus('opening');
  }, [componentRef, afterOpen]);
  var openModal = (0, _react.useCallback)(function () {
    clearListeners();
    addBodyClasses();
    setStatus('beforeopen');
    setTimeout(animateOpen, 100);
    if (typeof onToggle === 'function') onToggle(true);
  }, [clearListeners, addBodyClasses, animateOpen, onToggle]);
  var closeModal = (0, _react.useCallback)(function () {
    removeBodyClasses();
    setStatus('closing');

    if (componentRef.current) {
      componentRef.current.addEventListener('transitionend', afterClose);
    }

    if (typeof onToggle === 'function') onToggle(true);
  }, [removeBodyClasses, afterClose, onToggle]);
  (0, _react.useEffect)(function () {
    bodyElem.current = document.body;
    htmlElem.current = document.documentElement;
    return function cleanup() {
      clearListeners();
      removeBodyClasses();
    };
  }, [clearListeners, removeBodyClasses]);
  return {
    status: status,
    componentRef: componentRef,
    openModal: openModal,
    closeModal: closeModal
  };
}

var _default = useAnimatedModalState;
exports["default"] = _default;